<template>
  <div class="container">
    <div class="redeemPrize-container">
      <div class="site-container body-container">
        <div class="header-title">
          兑换详细
        </div>
        <div class="site-section" v-if="prize.address">
          <router-link :to="{ name: 'my_site' }">修改</router-link>
          <div class="site-section_content">
            <div class="content-item">
              <p class="label">
                地址信息：
              </p>
              <p class="desc">{{ prize.address }}</p>
            </div>
            <div class="content-item">
              <p class="label">
                收货人姓名：
              </p>
              <p class="desc">{{ prize.name }}</p>
            </div>
            <div class="content-item">
              <p class="label">
                收货人电话：
              </p>
              <p class="desc">{{ prize.phone }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="prize-container body-container" v-if="prize.gift">
        <div class="header-title">奖品信息</div>
        <div class="prize-container_content">
          <img class="prize-image" :src="prize.gift.image_url" />
          <div class="prize-container_content-text">
            <p class="title">{{ prize.gift.name }}</p>
            <div class="desc">
              <p class="desc_title">
                所需积分: <span>{{ prize.order.integral }}</span>
              </p>
              <p class="desc_desc">
                数量: <span>{{ prize.gift.number }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="order_form-container body-container" v-if="prize.order">
        <div class="header-title">
          订单详情
        </div>
        <div class="order_form-section">
          <div class="order_form-section_content">
            <p class="text">
              订单编号：<span>{{ prize.order.order_number }}</span>
            </p>
            <p class="text">
              所需积分：<span
                >{{ prize.order.integral }}（剩余积分：
                {{ prize.order.integral_surplus }}）</span
              >
            </p>
            <p class="text">支付方式：<span>使用积分</span></p>
          </div>
        </div>
        <div class="redeemPrize-button">
          <router-link :to="{ name: 'redeem_the_prize_list' }">
            <el-button class="show-button" type="warning">返回</el-button>
          </router-link>
          <el-button type="warning" @click="saveData">提交兑换</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import giftService from "@/global/service/gift";
export default {
  data() {
    return {
      prize: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      giftService.addressDefault().then(res => {
        this.prize = res;
      });
    },
    saveData() {}
  }
};
</script>
<style lang="less" scoped>
.container {
  .redeemPrize-container {
    .body-container {
      background-color: #fff;
      margin-bottom: 10px;
      .header-title {
        width: 100%;
        border-bottom: 1px solid rgb(222, 222, 222);
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        font-size: 12px;
        text-align: left;
        color: #2c3e50;
      }
    }
    .site-container {
      .site-section {
        padding: 20px;
        text-align: right;
        a {
          text-decoration: none;
          color: #666;
          font-size: 14px;
        }
        .site-section_content {
          text-align: left;
          .content-item {
            display: flex;
          }
          .label {
            width: 120px;
            text-align: right;
            color: #333;
            line-height: 32px;
            font-size: 14px;
            margin-right: 10px;
          }
          .desc {
            color: #333;
            line-height: 32px;
            font-size: 14px;
          }
        }
      }
    }
    .prize-container {
      .prize-container_content {
        padding: 20px;
        display: flex;
        .prize-image {
          width: 120px;
          height: 120px;
        }
        .prize-container_content-text {
          flex: 1;
          text-align: left;
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          .title {
            font-size: 12px;
            color: #333;
            height: 40px;
          }
          .desc {
            display: flex;
            .desc_title,
            .desc_desc {
              font-size: 12px;
              color: #333;
              span {
                color: #f0b32f;
              }
            }
            .desc_title {
              margin-right: 30px;
            }
          }
        }
      }
    }
    .order_form-section {
      padding: 20px;
      text-align: left;
      .text {
        color: #333;
        line-height: 32px;
        font-size: 13px;
        span {
          margin-left: 30px;
        }
      }
    }
  }
  .redeemPrize-button {
    padding: 10px;
    text-align: left;
    .show-button {
      background-color: #fff;
      color: rgb(240, 179, 47);
    }
    a {
      margin-right: 20px;
    }
  }
}
</style>
